import type { FunctionComponent, PropsWithChildren } from 'react'
import React, { createContext, useContext, useMemo } from 'react'

type SchemeContextType = {
  scheme: 'default' | 'inverted'
}

const SchemeContext = createContext<SchemeContextType>({ scheme: 'default' })

export const SchemeContextProvider: FunctionComponent<PropsWithChildren<{ scheme: 'default' | 'inverted' }>> = ({ scheme, children }) => {
  const parentContext = useSchemeContext()

  const value = useMemo<SchemeContextType>(() => {
    return {
      ...parentContext,
      scheme,
    }
  }, [parentContext, scheme])

  return <SchemeContext value={value}>{children}</SchemeContext>
}

export const useSchemeContext = () => {
  return useContext(SchemeContext)
}
